import { supabase as supabaseClient } from "@/lib/supabaseClient";

export const supabase = supabaseClient;
